export default __webpack_public_path__ + "static/media/Product-versions-noretire.2b7b9bfe.svg";